import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { WorkstationCategoryDTO } from './workstation-category.dto';

export class AllWorkstationCategoryResponseModel extends GlobalResponseObject{
    data?: WorkstationCategoryDTO[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: WorkstationCategoryDTO[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}
